export function createPaymentAnalytics(client, gameCode) {
	const memory = new Map()
	const ttl = 2 * 60 * 60 * 1000
	const storageKey = () => `pa:payment:v2:${gameCode() || 'unknown'}`
	function read() {
		let value = memory.get(storageKey())
		try { value = JSON.parse(window.sessionStorage.getItem(storageKey()) || 'null') || value } catch (_) { /* Optional storage. */ }
		return value && typeof value.createdAt === 'number' && value.properties && typeof value.properties === 'object'
			&& Date.now() >= value.createdAt && Date.now() - value.createdAt < ttl ? value : null
	}
	function write(value) {
		memory.set(storageKey(), value)
		try { window.sessionStorage.setItem(storageKey(), JSON.stringify(value)) } catch (_) { /* Optional storage. */ }
	}
	function id() {
		return typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID
			? window.crypto.randomUUID() : `checkout-${Date.now()}-${Math.random().toString(36).slice(2)}`
	}
	function begin(properties = {}) {
		const value = { id: id(), createdAt: Date.now(), properties, started: false, result: null }
		write(value)
		client.track('checkout_started', { ...properties, checkout_id: value.id })
		return value
	}
	return {
		begin,
		started(properties = {}) {
			let value = read()
			if (!value || value.result || value.started || value.properties.product_id !== properties.product_id) value = begin(properties)
			value.properties = properties
			value.started = true
			write(value)
			client.track('payment_started', { ...properties, checkout_id: value.id })
		},
		result(success) {
			let value = read()
			const correlated = Boolean(value && value.started)
			const eventName = success ? 'payment_success' : 'payment_failed'
			// Direct result-page visits are observed without inventing an order or product.
			if (!value || !value.started) {
				if (value && value.result === eventName) return false
				value = { id: id(), createdAt: Date.now(), properties: {}, started: false }
			}
			if (value.result === eventName) return false
			const result = client.track(eventName, {
				...(correlated ? value.properties : {}),
				checkout_id: correlated ? value.id : null,
				confirmation_source: success ? 'success_page' : 'error_page',
				result_page: success ? '/success' : '/error',
				correlation_status: correlated ? 'same_tab_checkout' : 'unmatched',
				server_confirmed: false
			})
			if (!result) return false
			value.result = eventName
			write(value)
			client.flush()
			return true
		}
	}
}
